import { syncURLParams } from "./searchHelpers";

export const applyFilterURL = (filters) => {
  const searchParams = new URLSearchParams(window.location.search);
  if (filters.country) {
    searchParams.set("country", filters.country.value);
  } else {
    searchParams.delete("country");
  }

  if (filters.searchType) {
    searchParams.set("type", filters.searchType);
  } else {
    searchParams.delete("type");
  }

  if (filters.tag.length) {
    searchParams.set("suitable_for", filters.tag.join(","));
  } else {
    searchParams.delete("suitable_for");
  }

  syncURLParams(searchParams);
};

export const ALL_COUNTRIES = [
  {
    slug: "bahamas",
    title: "Bahamas",
    code: "BH",
  },
  {
    slug: "belize",
    title: "Belize",
    code: "BZ",
  },
  {
    slug: "cayman-islands",
    title: "Cayman Islands",
    code: "CI",
  },
  {
    slug: "colombia",
    title: "Malpelo",
    code: "CO",
  },
  {
    slug: "costa-rica",
    title: "Cocos Island",
    code: "CR",
  },
  {
    slug: "fiji",
    title: "Fiji",
    code: "FJ",
  },
  {
    slug: "ecuador",
    title: "Galapagos",
    code: "EC",
  },
  {
    slug: "honduras",
    title: "Honduras",
    code: "HO",
  },
  {
    slug: "indonesia",
    title: "Indonesia",
    code: "ID",
  },
  {
    slug: "lesser-antilles",
    title: "Eastern Caribbean",
    code: "LA",
  },
  {
    slug: "malaysia",
    title: "Malaysia",
    code: "MY",
  },
  {
    slug: "maldives",
    title: "Maldives",
    code: "MV",
  },
  {
    slug: "mexico",
    title: "Mexico",
    code: "MX",
  },
  {
    slug: "new-zealand",
    title: "New Zealand",
    code: "NZ",
  },
  {
    slug: "pacific",
    title: "Pacific Islands",
    code: "PC",
  },
  {
    slug: "philippines",
    title: "Philippines",
    code: "PH",
  },
  {
    slug: "portugal",
    title: "Portugal",
    code: "PT",
  },
  {
    slug: "red-sea",
    title: "Red Sea (Egypt)",
    code: "RS",
  },
  {
    slug: "thailand",
    title: "Thailand",
    code: "TH",
  },
  {
    slug: "turks-caicos",
    title: "Turks and Caicos",
    code: "TC",
  },
  {
    slug: "seychelles",
    title: "Seychelles",
    code: "SC",
  },
  {
    slug: "dominican-republic",
    title: "Dominican Republic",
    code: "DO",
  },
];
